// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file AirSpaceBoundaryVertex.proto (package AirSpaceBoundaryVertex, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { CoordPoint } from "./CoordPoint_pb";
import { file_CoordPoint } from "./CoordPoint_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file AirSpaceBoundaryVertex.proto.
 */
export const file_AirSpaceBoundaryVertex: GenFile = /*@__PURE__*/
  fileDesc("ChxBaXJTcGFjZUJvdW5kYXJ5VmVydGV4LnByb3RvEhZBaXJTcGFjZUJvdW5kYXJ5VmVydGV4IqoDChZBaXJTcGFjZUJvdW5kYXJ5VmVydGV4EioKCmNvb3JkUG9pbnQYASABKAsyFi5Db29yZFBvaW50LkNvb3JkUG9pbnQSKgoEbmFtZRgCIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIuCghpZFZlcnRleBgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRInCgJpZBgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjMKDnNlcXVlbmNlbnVtYmVyGAUgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLgoIdW5pcXVlaWQYBiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSQQocYWlyc3BhY2Vib3VuZGFyeUNvb3JkUG9pbnRQaxgHIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjcKEmFpcnNwYWNlYm91bmRhcnlQaxgIIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlQkwKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIbQWlyU3BhY2VCb3VuZGFyeVZlcnRleFByb3RvYgZwcm90bzM", [file_CoordPoint, file_google_protobuf_wrappers]);

/**
 * @generated from message AirSpaceBoundaryVertex.AirSpaceBoundaryVertex
 */
export type AirSpaceBoundaryVertex = Message<"AirSpaceBoundaryVertex.AirSpaceBoundaryVertex"> & {
  /**
   * @generated from field: CoordPoint.CoordPoint coordPoint = 1;
   */
  coordPoint?: CoordPoint;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue idVertex = 3;
   */
  idVertex?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 4;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.Int32Value sequencenumber = 5;
   */
  sequencenumber?: number;

  /**
   * @generated from field: google.protobuf.StringValue uniqueid = 6;
   */
  uniqueid?: string;

  /**
   * @generated from field: google.protobuf.Int32Value airspaceboundaryCoordPointPk = 7;
   */
  airspaceboundaryCoordPointPk?: number;

  /**
   * @generated from field: google.protobuf.Int32Value airspaceboundaryPk = 8;
   */
  airspaceboundaryPk?: number;
};

/**
 * Describes the message AirSpaceBoundaryVertex.AirSpaceBoundaryVertex.
 * Use `create(AirSpaceBoundaryVertexSchema)` to create a new message.
 */
export const AirSpaceBoundaryVertexSchema: GenMessage<AirSpaceBoundaryVertex> = /*@__PURE__*/
  messageDesc(file_AirSpaceBoundaryVertex, 0);

